import React from "react";

import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import MealRatingIcon from "../../../ClientDiary/Meals/components/MealRatingIcon";

const useStyles = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "row-reverse",
  },
  icon: {
    height: 24,
    width: 24,
  },
  legend: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  legendColor: {
    borderRadius: 2,
    height: 12,
    width: 12,
    marginLeft: 4,
    marginRight: 24,
  },
}));

const ratings: Record<number, string> = {
  5: "#FF9524",
  4: "#FBB631",
  3: "#BFDA86",
  2: "#6EE2EA",
  1: "#F27373",
};

const WeeklyRatingGraphLegends: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      {Object.entries(ratings).map(([rating, color]) => (
        <Box key={rating} className={classes.legend}>
          <MealRatingIcon rating={Number(rating)} className={classes.icon} />
          <Box bgcolor={color} className={classes.legendColor} />
        </Box>
      ))}
    </Box>
  );
};

export default WeeklyRatingGraphLegends;
